import { axios } from '@/lib/helpers';
import { createAction } from '@reduxjs/toolkit';

import { addProductTab } from '@/lib/redux/redux-actions';

// Helpers
import { BASE_URLS } from '@/lib/helpers';

export const quickSearchReset = createAction('quickSearch/reset');
export const quickSearchStarted = createAction('quickSearch/started');
export const quickSearchSucceeded = createAction('quickSearch/succeeded');
export const quickSearchFailed = createAction('quickSearch/failed');

export const makeQuickSearch =
  ({ searchParams, history }) =>
  (dispatch, getState) => {
    const { type, keyword } = searchParams;

    const state = getState();
    const userState = state.user;
    let { user, chainUrls } = userState;

    dispatch(quickSearchStarted());

    return axios({
      method: 'get',
      crossdomain: true,
      params: {
        type,
        keyword: encodeURIComponent(keyword.trim()),
        userId: user.uuid,
      },
      url: `${chainUrls.QUICK_SEARCH}`,
    }).then(
      ({ data }) => {
        if (data.result) {
          dispatch(quickSearchSucceeded(data.result.uuid));
          dispatch(
            addProductTab({
              productUuids: [data.result.uuid],
              mapping: { [data.result.uuid]: data.result },
            })
          );
          // history.push(`${BASE_URLS['pim']}/tuote/${data.result.uuid}`);
        } else {
          dispatch(quickSearchFailed());
        }
      },
      ({ message }) => dispatch(quickSearchFailed(message))
    );
  };
